var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Speaker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speaker",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.413797,0.0764246861 C13.150036,-0.0508282863 12.8368995,-0.0172779528 12.6060845,0.162965312 L5.88476256,5.38424974 L1.53850002,5.38424974 C0.68880992,5.38424974 0,6.07305966 0,6.92274976 L0,13.0767498 C0,13.9264399 0.68880992,14.6152498 1.53850002,14.6152498 L5.88476256,14.6152498 L12.6060845,19.8365343 C12.7402681,19.9424943 12.9062742,20 13.0772501,20 C13.1936299,19.998613 13.3083714,19.9723863 13.413797,19.9230749 C13.6786988,19.7941914 13.8467304,19.5253409 13.8465004,19.2307499 L13.8465004,0.768749693 C13.8467304,0.474158691 13.6786988,0.205308199 13.413797,0.0764246861 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9235002,6.92274976 C16.4986551,6.92274976 16.1542502,7.26715472 16.1542502,7.69199977 L16.1542502,12.3074998 C16.1542502,12.7323449 16.4986551,13.0767498 16.9235002,13.0767498 C17.3483452,13.0767498 17.6927502,12.7323449 17.6927502,12.3074998 L17.6927502,7.69199977 C17.6927502,7.26715472 17.3483452,6.92274976 16.9235002,6.92274976 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0005002,5.38424974 C19.5756552,5.38424974 19.2312502,5.7286547 19.2312502,6.15349975 L19.2312502,13.8459998 C19.2312502,14.2708449 19.5756552,14.6152498 20.0005002,14.6152498 C20.4253453,14.6152498 20.7697502,14.2708449 20.7697502,13.8459998 L20.7697502,6.15349975 C20.7697502,5.7286547 20.4253453,5.38424974 20.0005002,5.38424974 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/Speaker.a1cca837e56b6e4c77b4ec76b3c3bdae.svg";
export { ForwardRef as ReactComponent };